import { Component, DestroyRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { PageTitleService } from '@ieCore/services/page-title.service';
import { SvgIconsService } from '@ieCore/services/svg-icons.service';
import { RegionService } from '@ieCore/services/region.service';
import { FileViewerComponent } from '@ieShared/components/file-viewer/file-viewer.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalStorageListenerService } from '@ieCore/services/local-storage-listener.service';
import { STORAGE_KEY } from '@ieCore/consts/auth.consts';
import { AuthService } from '@ieCore/services/auth.service';
import { IdleTimeoutService } from '@ieCore/services/idle-timeout.service';
import { selectUser } from '@ieApp/store/user/user.selectors';

declare const window: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FileViewerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(
    private pageTitleService: PageTitleService,
    private svgIconService: SvgIconsService,
    private regionService: RegionService,
    private destroyRef: DestroyRef,
    private authService: AuthService,
    private localStorageListenerService: LocalStorageListenerService,
    private idleTimeoutService: IdleTimeoutService,
    private store: Store,
  ) {
    this.pageTitleService.init();
    this.svgIconService.loadSvgSprite('assets/ie-icons.svg');
    this.regionService.initRegions();
    this.localStorageListenerService.storageChanges$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event.key !== STORAGE_KEY) {
          return;
        }

        if (!event.value || !event.oldValue) {
          window.location.reload();
          return;
        }

        const value = this.authService.getUserIdFromToken(event.value);
        const oldValue = this.authService.getUserIdFromToken(event.value);

        if (value !== oldValue) {
          window.location.reload();
        }
      });

    // Item 11: idle-logout tracking is gated on authenticated state — starts
    // when the user store is populated (login), stops when it's cleared
    // (logout, incl. the idle timeout's OWN logout). IdleTimeoutService
    // itself is INERT for tenants without Org.idleLogoutMinutes configured.
    this.store
      .select(selectUser)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        if (user) {
          this.idleTimeoutService.start();
        } else {
          this.idleTimeoutService.stop();
        }
      });
  }
}
